export enum TemplateType {
  Chat = 0,
  Email = 1,
  Zns = 2,
  Sms = 3,
}

export enum TemplateContext {
  Chat = 'Biểu mẫu chat',
  Email = 'Biểu mẫu email',
  Zns = 'Biểu mẫu ZNS',
  Sms = 'Biểu mẫu SMS',
}

export interface Field {
  id: string;
  text: string;
  type: any;
}

export enum FieldType {
  User = 'user',
  Ticket = 'ticket',
  Expert = 'expert',
}

export enum FieldTypeContext {
  User = 'Khách hàng',
  Ticket = 'Ticket',
  Expert = 'Chuyên viên',
}

export const FieldTypeLabel = {
  [FieldType.User]: FieldTypeContext.User,
  [FieldType.Ticket]: FieldTypeContext.Ticket,
  [FieldType.Expert]: FieldTypeContext.Expert,
};
export const UserField: Field[] = [
  {
    id: FieldType.User + ':name',
    text: 'Tên khách hàng',
    type: FieldType.User,
  },
  {
    id: FieldType.User + ':phone',
    text: 'Điện thoại khách hàng',
    type: FieldType.User,
  },
  {
    id: FieldType.User + ':email',
    text: 'Email khách hàng',
    type: FieldType.User,
  },
  {
    id: FieldType.User + ':address',
    text: 'Địa chỉ khách hàng',
    type: FieldType.User,
  },
  {
    id: FieldType.User + ':gender',
    text: 'Giới tính khách hàng',
    type: FieldType.User,
  },
  {
    id: FieldType.User + ':note',
    text: 'Ghi chú của khách hàng',
    type: FieldType.User,
  },
  {
    id: FieldType.User + ':customer_type',
    text: 'Hạng khách hàng',
    type: FieldType.User,
  },
];
export const TicketField: Field[] = [
  { id: FieldType.Ticket + ':code', text: 'Mã ticket', type: FieldType.Ticket },
  {
    id: FieldType.Ticket + ':subject',
    text: 'Chủ đề ticket',
    type: FieldType.Ticket,
  },
  {
    id: FieldType.Ticket + ':type_id',
    text: 'Loại ticket',
    type: FieldType.Ticket,
  },
  {
    id: FieldType.Ticket + ':duedate',
    text: 'Hạn xử lý của ticket',
    type: FieldType.Ticket,
  },
  {
    id: FieldType.Ticket + ':source_detail',
    text: 'Nguồn của ticket',
    type: FieldType.Ticket,
  },
  {
    id: FieldType.Ticket + ':status',
    text: 'Trạng thái của ticket',
    type: FieldType.Ticket,
  },
  {
    id: FieldType.Ticket + ':priority_id',
    text: 'Độ ưu tiên của ticket',
    type: FieldType.Ticket,
  },
];
export const ExpertField: Field[] = [
  {
    id: FieldType.Expert + ':name',
    text: 'Tên chuyên viên',
    type: FieldType.Expert,
  },
  {
    id: FieldType.Expert + ':phone',
    text: 'Điện thoại chuyên viên',
    type: FieldType.Expert,
  },
  {
    id: FieldType.Expert + ':email',
    text: 'Email chuyên viên',
    type: FieldType.Expert,
  },
  {
    id: FieldType.Expert + ':role',
    text: 'Vai trò của chuyên viên',
    type: FieldType.Expert,
  },
  {
    id: FieldType.Expert + ':group_id',
    text: 'Bộ phận của chuyên viên',
    type: FieldType.Expert,
  },
];

export class TemplateConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên biểu mẫu',
        key: 'template_name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Loại biểu mẫu',
        key: 'display_type',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Mô tả',
        key: 'note',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static templateTypeString = type => {
    switch (type) {
      case TemplateType.Chat:
      case TemplateType.Chat.toString():
        return `<small class="badge badge-info">` + TemplateContext.Chat + `</small>`;
      case TemplateType.Email:
      case TemplateType.Email.toString():
        return `<small class="badge badge-warning">` + TemplateContext.Email + `</small>`;
      case TemplateType.Zns:
      case TemplateType.Zns.toString():
        return `<small class="badge badge-primary">` + TemplateContext.Zns + `</small>`;
      case TemplateType.Sms:
      case TemplateType.Sms.toString():
        return `<small class="badge badge-success">` + TemplateContext.Sms + `</small>`;
      default:
        return `<small class="badge badge-default">Biểu mẫu ` + type + `</small>`;
    }
  };
  static typeTemplate = () => {
    return [
      { id: TemplateType.Chat.toString(), text: TemplateContext.Chat },
      { id: TemplateType.Email.toString(), text: TemplateContext.Email },
      { id: TemplateType.Zns.toString(), text: TemplateContext.Zns },
      { id: TemplateType.Sms.toString(), text: TemplateContext.Sms },
    ];
  };
  static buildAttributes = data => {
    const attributes = {};
    Object.keys(data).forEach(key => {
      const value = data[key].split(':');
      switch (value[0]) {
        case FieldType.Ticket:
          attributes[key] = {
            object: 'ticket',
            property: value[1],
          };
          break;
        case FieldType.User:
          attributes[key] = {
            object: 'ticket',
            property: 'requester_id',
            extra: {
              object: 'user',
              property: value[1],
            },
          };
          break;
        case FieldType.Expert:
          attributes[key] = {
            object: 'ticket',
            property: 'assign_agent_id',
            extra: {
              object: 'user',
              property: value[1],
            },
          };
          break;
        default:
          break;
      }
    });
    return attributes;
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/other/template/template.const.ts